import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a21f56d9c9642ec69c784bc7b37daf83.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center w-full py-32">
        <div className="animate-fade-in">
          <h1
            className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Transforme Seu Corpo,<br />
            <span className="text-[#D0C8BF]">Eleve Sua Autoestima</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
            Tratamentos exclusivos de emagrecimento e estética com tecnologia avançada e equipe especializada
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => scrollToSection('contato')}
              className="px-10 py-4 bg-[#915726] text-white text-lg font-medium rounded-full hover:bg-[#7A3010] transition-all duration-300 shadow-2xl hover:shadow-[#915726]/50 hover:scale-105 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Agende Sua Avaliação
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className="px-10 py-4 bg-white/10 backdrop-blur-md text-white text-lg font-medium rounded-full hover:bg-white/20 transition-all duration-300 border-2 border-white/30 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Conheça Nossos Serviços
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-24">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="w-16 h-16 flex items-center justify-center bg-[#915726] rounded-full mx-auto mb-4">
              <i className="ri-award-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              +15 Anos
            </h3>
            <p className="text-white/80 text-sm">
              De experiência em tratamentos estéticos
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="w-16 h-16 flex items-center justify-center bg-[#915726] rounded-full mx-auto mb-4">
              <i className="ri-user-heart-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              +5.000
            </h3>
            <p className="text-white/80 text-sm">
              Clientes transformados e satisfeitos
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="w-16 h-16 flex items-center justify-center bg-[#915726] rounded-full mx-auto mb-4">
              <i className="ri-star-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              98%
            </h3>
            <p className="text-white/80 text-sm">
              Taxa de satisfação dos nossos clientes
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <button
          onClick={() => scrollToSection('servicos')}
          className="w-12 h-12 flex items-center justify-center text-white/80 hover:text-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-3xl"></i>
        </button>
      </div>
    </section>
  );
}